// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
// Services
import { SystemApiService } from '@cv-invision/core';
// Models
import { ImportFormModel } from '../model/import-form.model';
import { OrderReviewResponse } from '../state/model/import-state.model';
// Others
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const SCHEMA_CVReview1 = 'CVReview:1';

@Injectable({providedIn: 'root'})
export class ImportOrderService {
	constructor(private httpClient: HttpClient,
				private systemApiService: SystemApiService) {
	}

	/**
	 * Get List of Forms
	 */
	public getForms(): Observable<any[]> {
		return this.httpClient.get(
			this.systemApiService.api.intelligenceService + 'orders/forms').pipe(
			map((payload: any) => {
				return payload.filter((form: any) => form.schema !== SCHEMA_CVReview1);
			})
		);
	}

	/**
	 * Get List of Apps
	 */
	public getApps(): Observable<any[]> {
		return this.httpClient.get(
			this.systemApiService.api.intelligenceService + 'orders/apps').pipe(
			map((payload: any) => {
				return payload;
			})
		);
	}

	/**
	 * Import the value
	 * @param importFormModel
	 */
	public importOrder(importForm: ImportFormModel): Observable<any[]> {
		const params = {
			form: importForm.form.form,
			schema: importForm.form.schema,
			app: importForm.app.appKey,
			parameters: {},
			deleteDuplicates: importForm.deleteDuplicates
		};
		let importNumber = importForm.number;
		if (importNumber !== null) {
			importNumber = +importNumber
				.toString()
				.replace(/[\\"']/g, '\\$&')
				.replace(/u0000/g, '\\0');
		}
		params.parameters[importForm.paramName] = isNaN(importNumber) ? null : importNumber;

		return this.httpClient.post(
			this.systemApiService.api.intelligenceService + 'orders/review/import', params).pipe(
			map((payload: any) => {
				return payload;
			})
		);
	}

	/**
	 * get whether is an order exist already in the system
	 * @param referenceId
	 */
	public getDuplicateOrder(referenceId: number, formType: string): Observable<any> {
		return this.httpClient.get(
			this.systemApiService.api.intelligenceService + `order-details/search?ExternalId=${referenceId}&FormType=${formType}&limit=1`)
			.pipe(
				map((payload: any) => {
					return payload;
				})
			);
	}

	/**
	 * get orders that have been imported
	 */
	public getOrdersReview(page: number): Observable<OrderReviewResponse> {
		const requestType = ['Enqueue', 'Processing', 'Failed'];
		let params = new HttpParams();
		const limit = 10;
		requestType.forEach(p => (params = params.append('requestType', p)));
		params = params.append('offset', page.toString());
		params = params.append('limit', limit.toString());
		return this.httpClient.get(
			this.systemApiService.api.intelligenceService + 'orders/review/requests?', {params: params})
			.pipe(
				map((payload: any) => {
					return payload;
				})
			);
	}
}
